import React from 'react';
import { AssignmentsBasedGradesTableProps } from './store/createGradesTableStore';
import GradesTableStoreProvider from './store/GradesTableStoreProvider';
import Table from './Table/Table';
import Navigation from './Navigation';

const AssignmentsBasedGradesTable = (props : AssignmentsBasedGradesTableProps) => (
  <GradesTableStoreProvider props={props}>
    <Navigation />
    <Table />
  </GradesTableStoreProvider>
);

export default AssignmentsBasedGradesTable;
